import React from "react";
import InputForm from "../../Shared/InputForm/InputForm";
import {
  getEnviormentPropByName,
  getUIURLs,
} from "../../../constants/microservice-helpers";
class MsidOpenAuthURL extends InputForm {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      actionurl: "",
      clientid: "",
      responsetype: "",
      acrvalue: "",
      redirecturi: "",
      scope: "",
    };
  }

  componentDidMount() {
    const { whiteLabel, setApplicationContext } = this.props;
    this.setState({
      actionurl: getEnviormentPropByName("REACT_APP_MSID_OAUTH_URL"),
    });
    this.setState({
      clientid: getEnviormentPropByName("REACT_APP_MSID_CLIENT_ID"),
    });
    this.setState({
      responsetype: getEnviormentPropByName(
        "REACT_APP_MSID_CLIENT_RESPONSE_TYPE"
      ),
    });
    this.setState({
      acrvalue: getEnviormentPropByName("REACT_APP_MSID_ACR_VALUES"),
    });
    if (whiteLabel) {
      this.setState({
        redirecturi: setApplicationContext && setApplicationContext !== undefined
          ? getEnviormentPropByName("REACT_APP_WHITELABEL_URL") +
          setApplicationContext.basename +
          getEnviormentPropByName("REACT_APP_MSID_REDIRECT_URI")
          : getEnviormentPropByName("REACT_APP_WHITELABEL_URL") +
          getEnviormentPropByName("REACT_APP_MSID_REDIRECT_URI")
      });
    } else {
      this.setState({
        redirecturi: getUIURLs(getEnviormentPropByName("REACT_APP_MSID_REDIRECT_URI")),
      });
    }
    
    this.setState({
      scope: getEnviormentPropByName("REACT_APP_MSID_SCOPE"),
    });
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.addListener(props);
  }

  addListener(props) {
    if (this && this.state && this.state.actionurl) {
      if (props) {
        this.containerRef.current.submit();
      }
    }
  }

  render() {
    const {
      actionurl,
      clientid,
      responsetype,
      acrvalue,
      redirecturi,
      scope,
    } = this.state;
    return (
      <React.Fragment>
        <form method="post" ref={this.containerRef} action={actionurl || ""}>
          <div>
            <input type="hidden" name="client_id" value={clientid || ""} />
            <input
              type="hidden"
              name="response_type"
              value={responsetype || ""}
            />
            <input type="hidden" name="acr_values" value={acrvalue || ""} />
            <input
              type="hidden"
              name="redirect_uri"
              value={redirecturi || ""}
            />
            <input type="hidden" name="scope" value={scope || ""} />
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default MsidOpenAuthURL;
